import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BooleanCons } from 'src/app/constants/const';
import { ImageViewerComponent } from 'src/app/dialogs/image-viewer/image-viewer.component';
import { ImageViewerStructor } from 'src/app/model/http/container-selector.model';
import { CallPlace, IProducts } from 'src/app/model/http/myActivity.model';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.scss'],
})
export class ProductImageComponent implements OnInit, OnChanges {
  @Input() product = new IProducts();
  @Input() imgUrl = false;
  @Input() showBorder = true;
  @Input() circle = true;
  @Input() radius = false;
  @Input() imageOpacity = BooleanCons.false;
  constructor(private dialogService: DialogService) { }

  ngOnInit(): void {
    this.validate();
  }

  validate(): void {
    if (this.imgUrl) {
      this.product.imgProduct = this.product.imageUrl;
    }
  }

  openImageViewer(): void {
    const dialogConfig = new MatDialogConfig();
    const data = new ImageViewerStructor();
    data.product = this.product;
    data.callPlace = CallPlace.default;
    dialogConfig.data = data;
    this.dialogService.displayDialog(ImageViewerComponent, dialogConfig);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.validate();
  }
}
